import { FC } from "react";

import { IconProps } from "./IconProps";

export const Minus: FC<IconProps> = ({
  className,
  size = 16,
  color = "currentColor",
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 31 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M30.6 18.56H0V13.58H30.6V18.56Z" fill={color} />
  </svg>
);
